import Vue from 'vue'

export const createVueInstance = (component) => {
  const instance = new Vue(component)
  document.body && document.body.appendChild(instance.$mount().$el)
  return instance
}

export const serialize = (obj) => {
  let s = []

  for (let item in obj) {
    const k = encodeURIComponent(item)
    const v = encodeURIComponent(obj[item] === null ? '' : obj[item])
    s.push(`${k}=${v}`)
  }
  return s.join('&')
}

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

/**
 * UA
 * @type {string}
 */
export const UA = window.navigator.userAgent

/**
 * Device detect
 * @example
 * if (device.iOS) ssomething()
 *
 * @type {Object}
 */
export const device = {
  iOS: /iPhone|iPad|iPod/i.test(UA),
  Android: /Android/i.test(UA)
}

export const getDateArray = (date) => {
  return [date.getFullYear(), date.getMonth() + 1, date.getDate()]
}

export const formatDate = (date, fmt) => {
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1)
        ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

export const zeroPad = n => String(n < 10 ? '0' + n : n)

/**
 * Type detect
 * @prop {Function} regExp check if some value is RegExp
 * @prop {Function} string check if some value is string
 * @prop {Function} function check if some value is function
 * @prop {Function} object check if some value is object
 * @prop {Function} boolean check if some value is boolean
 * @example
 * if (is.regExp(regexp)) something()
 */
export const is = (type) => (obj) => toString.call(obj) === `[object ${type}]`

is.regExp = is('RegExp')
is.string = is('String')
is.function = is('Function')
is.object = is('Object')
is.boolean = is('Boolean')

/**
 * Usage:
 * {{ 'Wed Jun 21 2017 01:34:33 GMT+0800 (CST)' | moment('MMM, hh:mm YYYY-MM-DD') }}
 *
 * Sample:
 * Tue, 24:00, 2018-07-11  dd, hh:mm, YYYY-MM-DD
 * 12 February DD MMMM
 * 12 Feb DD MMM
 *
 */
export const dateFormat = (dateStr, formatStr) => {
  const d = new Date(dateStr)
  if (toString.call(d) !== '[object Date]' || isNaN(d.getTime())) {
    return dateStr
  }

  const months = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
  const monthsShort = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
  const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']

  let obj = {
    'YYYY': d.getFullYear(),
    'dd': weekdays[d.getDay()]
  }

  let MM = d.getMonth() + 1
  obj.MM = (MM > 9 ? '' : '0') + MM
  obj.MMM = monthsShort[d.getMonth()]
  obj.MMMM = months[d.getMonth()]

  let DD = d.getDate()
  obj.DD = (DD > 9 ? '' : '0') + DD

  let hh = d.getHours()
  obj.hh = (hh > 9 ? '' : '0') + hh

  let mm = d.getMinutes()
  obj.mm = (mm > 9 ? '' : '0') + mm

  let ss = d.getSeconds()
  obj.ss = (ss > 9 ? '' : '0') + ss

  let str = formatStr
  const order = ['YYYY', 'MMMM', 'MMM', 'MM', 'DD', 'dd', 'hh', 'mm', 'ss']
  order.forEach((key) => {
    str = str.replace(key, obj[key])
  })

  return str
}

export const getViewportScale = () => {
  const viewport = document.querySelector('meta[name=viewport]')
  if (!viewport) {
    return 1
  }
  const content = viewport.getAttribute('content')
  if (!content) {
    return 1
  }
  const matched = content.match(/initial-scale=(.*?),/)
  if (!matched) {
    return 1
  }
  return matched[1]
}



// WEBPACK FOOTER //
// ./src/utils/index.js